export const SHARE_URLS = {
    facebook: 'https://www.facebook.com/sharer/sharer.php',
    twitter: 'https://twitter.com/intent/tweet',
    whatsapp: 'https://api.whatsapp.com/send',
};

export const LINK_SHARE_UTM_MEDIUM = 'link_shared_from_pimster';
export const COPY_TO_CLIPBOARD_SHARE_UTM_SOURCE = 'link';
export const COPY_TO_CLIPBOARD_SHARE_UTM_MEDIUM = 'link_copied_from_pimster';

export const WITH_URL_VALIDATION_ERROR =
    "[Share]: prop 'url' is invalid. The components won't render.";
